import { render, staticRenderFns } from "./ActivityItemH5.vue?vue&type=template&id=979c0c3a&scoped=true&"
import script from "./ActivityItemH5.vue?vue&type=script&lang=js&"
export * from "./ActivityItemH5.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItemH5.vue?vue&type=style&index=0&id=979c0c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979c0c3a",
  null
  
)

export default component.exports